import { Dimensions, Platform } from 'react-native';
const {
  height: WINDOW_HEIGHT,
  width: WINDOW_WIDTH
} = Dimensions.get('window');
var GESTURE;

(function (GESTURE) {
  GESTURE[GESTURE["UNDETERMINED"] = 0] = "UNDETERMINED";
  GESTURE[GESTURE["CONTENT"] = 1] = "CONTENT";
  GESTURE[GESTURE["HANDLE"] = 2] = "HANDLE";
})(GESTURE || (GESTURE = {}));

var SHEET_STATE;

(function (SHEET_STATE) {
  SHEET_STATE[SHEET_STATE["CLOSED"] = 0] = "CLOSED";
  SHEET_STATE[SHEET_STATE["OPENED"] = 1] = "OPENED";
  SHEET_STATE[SHEET_STATE["EXTENDED"] = 2] = "EXTENDED";
  SHEET_STATE[SHEET_STATE["OVER_EXTENDED"] = 3] = "OVER_EXTENDED";
  SHEET_STATE[SHEET_STATE["FULL_SCREEN"] = 4] = "FULL_SCREEN";
})(SHEET_STATE || (SHEET_STATE = {}));

var SCROLLABLE_STATE;

(function (SCROLLABLE_STATE) {
  SCROLLABLE_STATE[SCROLLABLE_STATE["LOCKED"] = 0] = "LOCKED";
  SCROLLABLE_STATE[SCROLLABLE_STATE["UNLOCKED"] = 1] = "UNLOCKED";
})(SCROLLABLE_STATE || (SCROLLABLE_STATE = {}));

var ANIMATION_STATE;

(function (ANIMATION_STATE) {
  ANIMATION_STATE[ANIMATION_STATE["UNDETERMINED"] = 0] = "UNDETERMINED";
  ANIMATION_STATE[ANIMATION_STATE["RUNNING"] = 1] = "RUNNING";
  ANIMATION_STATE[ANIMATION_STATE["STOPPED"] = 2] = "STOPPED";
})(ANIMATION_STATE || (ANIMATION_STATE = {}));

var KEYBOARD_STATE;

(function (KEYBOARD_STATE) {
  KEYBOARD_STATE[KEYBOARD_STATE["UNDETERMINED"] = 0] = "UNDETERMINED";
  KEYBOARD_STATE[KEYBOARD_STATE["SHOWN"] = 1] = "SHOWN";
  KEYBOARD_STATE[KEYBOARD_STATE["HIDDEN"] = 2] = "HIDDEN";
})(KEYBOARD_STATE || (KEYBOARD_STATE = {}));

var ANIMATION_METHOD;

(function (ANIMATION_METHOD) {
  ANIMATION_METHOD[ANIMATION_METHOD["TIMING"] = 0] = "TIMING";
  ANIMATION_METHOD[ANIMATION_METHOD["SPRING"] = 1] = "SPRING";
})(ANIMATION_METHOD || (ANIMATION_METHOD = {}));

const SCROLLABLE_DECELERATION_RATE_MAPPER = {
  [SCROLLABLE_STATE.LOCKED]: 0,
  [SCROLLABLE_STATE.UNLOCKED]: Platform.select({
    ios: 0.998,
    android: 0.985,
    default: 1
  })
};
const MODAL_STACK_BEHAVIOR = {
  replace: 'replace',
  push: 'push'
};
const KEYBOARD_BEHAVIOR = {
  none: 'none',
  extend: 'extend',
  fullScreen: 'fullScreen',
  interactive: 'interactive'
};
const KEYBOARD_BLUR_BEHAVIOR = {
  none: 'none',
  restore: 'restore'
};
const KEYBOARD_DISMISS_THRESHOLD = 12.5;
export { GESTURE, SHEET_STATE, ANIMATION_STATE, SCROLLABLE_STATE, KEYBOARD_STATE, ANIMATION_METHOD, WINDOW_HEIGHT, WINDOW_WIDTH, SCROLLABLE_DECELERATION_RATE_MAPPER, MODAL_STACK_BEHAVIOR, KEYBOARD_BEHAVIOR, KEYBOARD_BLUR_BEHAVIOR, KEYBOARD_DISMISS_THRESHOLD };
//# sourceMappingURL=constants.js.map